module.exports = __webpack_public_path__ + "static/img/credicompras.96624676.svg";